import React from "react";
import styled from "styled-components";

const FloatingAction = styled.a`
  position: fixed;
  right: var(--spacing-small);
  bottom: var(--spacing-small);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.8rem;
  height: 4.8rem;
  color: white;
  background-color: #333333;
  border-radius: 100%;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    color: #ff73df;
    background: rgba(0, 0, 0, 0.25);
    border-bottom: none;
  }

  &:focus-visible {
    outline: none;
  }

  @media (min-width: 768px) {
    right: var(--spacing-large);
    bottom: var(--spacing-large);
  }
`;

const Chevron = styled.span`
  width: 1.2rem;
  height: 1.2rem;
  border-top: 2px solid currentColor;
  border-left: 2px solid currentColor;
  transform: translateY(0.3rem) rotate(45deg);
`;

const FloatingBackToTop = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const scrollToTop = (event) => {
    event.preventDefault();
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  };

  React.useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY > 0);

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });

    return () => window.removeEventListener("scroll", updateVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <FloatingAction href="#back-to-top" aria-label="Back to top" title="Back to top" onClick={scrollToTop}>
      <Chevron aria-hidden="true" />
    </FloatingAction>
  );
};

export default FloatingBackToTop;
